module.exports = __webpack_public_path__ + "img/fushimi-HP-012.0b0285ac.jpg";